<nz-tree-select style="width: 100%"
                nzTreeSelect
                nzShowSearch
                [(ngModel)]="value"
                [nzPlaceHolder]="placeholder"
                [nzSize]="size"
                [nzNodes]="tree"
                [nzDefaultExpandAll]="defaultExpandAll"
                [nzMultiple]="multipleSelect"></nz-tree-select>
